class GalleryModalController extends AbstractController
	@register()
	@inject 'image',
		'allowEdit'
		'MessageTerminal'

	initialize: ->
		@image.order ?= 0

	onOrderChange: ->
		@MessageTerminal.publish @MessageTerminal.events.GALLERY.EDIT_ORDER, @image

	onChange: ->
		@image.is_changed = true

		@MessageTerminal.publish @MessageTerminal.events.GALLERY.EDIT, @image
